var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1761_8170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.736 19.5772L18.176 14.9052L21.2554 21.9032L21.9367 19.5392H29.35C29.539 18.9134 29.634 18.263 29.632 17.6092C29.632 17.3292 29.6147 17.0539 29.582 16.7832L29.5854 16.8159C29.398 15.3979 28.6307 12.7486 25.5227 12.1399C25.0951 12.0534 24.6603 12.0069 24.224 12.0012H24.1267C23.4083 12.0128 22.6997 12.1703 22.044 12.464C21.3882 12.7577 20.799 13.1816 20.312 13.7099L20.3087 13.7132C19.8217 13.185 19.2328 12.7609 18.5774 12.4667C17.9219 12.1724 17.2137 12.0141 16.4954 12.0012H16.3974C15.9314 12.0086 15.482 12.0586 15.046 12.1479L15.0927 12.1399C12.8634 12.6226 11.1914 14.5026 11.0307 16.7999L11.03 16.8159C10.9359 17.7629 11.0353 18.7191 11.322 19.6266L11.3087 19.5766L16.736 19.5772Z",
    fill: "#FF4C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7646 20.6367L21.4746 25.1313L18.3586 18.052L17.5526 20.676H11.7246C12.7173 22.8733 15.0313 25.6307 20.3073 28C25.6506 25.6 27.9673 22.8393 28.9473 20.64L22.7646 20.6367Z",
    fill: "#FF4C5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1761_8170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6667,
    height: 16,
    fill: "white",
    transform: "translate(11 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/pulse.3fed3553a68a447a35b408e4c521eb1a.svg";
export { ForwardRef as ReactComponent };